import {inject, Injectable} from '@angular/core';
import {CompetitorArticleSyncApiService} from "./competitor-article-sync-api.service";
import {
  CompetitorArticleDta,
  SyncCompetitorArticleProductCard,
  SyncCompetitorArticleQueryParams
} from "../types/competitor-article-sync.types";

@Injectable({
  providedIn: 'root'
})
export class CompetitorArticleSyncService {
  private competitorArticleSyncApiService: CompetitorArticleSyncApiService = inject(CompetitorArticleSyncApiService);

  public fetchCompetitorArticlesList(queryParams: SyncCompetitorArticleQueryParams): Promise<Array<CompetitorArticleDta>> {
    return new Promise((resolve, reject) => {
      this.competitorArticleSyncApiService.fetchCompetitorArticlesList(queryParams).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }

  public fetchSyncCompetitorArticlesList(queryParams: SyncCompetitorArticleQueryParams): Promise<Array<CompetitorArticleDta>> {
    return new Promise((resolve, reject) => {
      this.competitorArticleSyncApiService.fetchSyncCompetitorArticlesList(queryParams).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }

  public attachCompetitorArticle(params :SyncCompetitorArticleProductCard): Promise<void> {
    return new Promise((resolve, reject) => {
      this.competitorArticleSyncApiService.attachCompetitorArticle(params).subscribe({
        next: () => resolve(),
        error: (error) => reject(error)
      });
    });
  }

  public detachCompetitorArticle(params :SyncCompetitorArticleProductCard): Promise<void> {
    return new Promise((resolve, reject) => {
      this.competitorArticleSyncApiService.detachCompetitorArticle(params).subscribe({
        next: () => resolve(),
        error: (error) => reject(error)
      });
    });
  }
}
